import http from '@/communication/AuthConnection'

export default (pData) => {
  return http.post('/v1/client', pData)
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/client/AddNewClient.js